import { Injectable } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

import { UrlInTranslationsPipe } from '../common';
import {
  DynamicText,
  DynamicTextRaw,
  DynamicTextTranslation,
  SelectOptionsT,
  SelectOptionT,
} from './types';

@Injectable({ providedIn: 'root' })
export class DynamicHelpers {
  constructor(
    private i18n: I18nService,
    private urlInTranslationsPipe: UrlInTranslationsPipe,
  ) {}

  public buildText(text: DynamicText): string {
    if ((<any>text).key) {
      // eslint-disable-next-line no-param-reassign
      text = <DynamicTextTranslation>text;

      let variables = text.variables;
      let links: any;

      if (variables) {
        [variables, links] = Object.keys(variables).reduce(
          ([v, l]: any, key) => {
            if (['a', 'a1', 'a2'].includes(key)) {
              return [v, { ...l, [key]: `target='_blank' href='${variables![key]}'` }];
            } else {
              return [{ ...v, [key]: variables![key] }, l];
            }
          },
          [undefined, undefined],
        );
      }

      const translated = this.i18n.translate(text['key'], variables);

      if (links) {
        return <string>this.urlInTranslationsPipe.transform(translated, links);
      } else {
        return translated;
      }
    } else if ((<any>text).text) {
      // eslint-disable-next-line no-param-reassign
      text = <DynamicTextRaw>text;
      return text.text;
    } else {
      return '';
    }
  }

  public buildOptions(options: SelectOptionsT): SelectOptionsT {
    return options.map((option: SelectOptionT) => {
      if (typeof option.label === 'string') {
        return option;
      } else {
        return { label: this.buildText(option.label), value: option.value };
      }
    });
  }
}
